(() => {
  if (window.__fourForXxxComparisonContainerInit) {
    return;
  }

  window.__fourForXxxComparisonContainerInit = true;

  const normalizeKey = (value) => (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const parseKeys = (value) => (value || '')
    .split(/[\n,]/)
    .map((item) => normalizeKey(item))
    .filter(Boolean);

  const updateIncludedBenefitsCountForContainer = (container) => {
    if (!container) return;

    const includedBenefitsTextElement = container.querySelector('[data-included-benefits-text]');
    if (!includedBenefitsTextElement) return;

    if (!includedBenefitsTextElement.dataset.baseText) {
      includedBenefitsTextElement.dataset.baseText = includedBenefitsTextElement.textContent.trim();
    }

    const baseText = includedBenefitsTextElement.dataset.baseText || '';
    const totalSecondaryRowsTrue = container.querySelectorAll('.benefits-included > li.is-true').length;

    includedBenefitsTextElement.textContent = totalSecondaryRowsTrue > 0
      ? `${totalSecondaryRowsTrue}`
      : baseText;
  };

  const updateIncludedBenefitsCount = (scope = document) => {
    const containers = scope.querySelectorAll('.four-for-xxx-comparison-container');
    containers.forEach(updateIncludedBenefitsCountForContainer);
  };

  const updateRankedNameBenefitsHeadingForContainer = (container) => {
    if (!container) return;

    const rankedNameBenefitsHeadingElement = container.querySelector('.ranked-name-benefits-heading');
    if (!rankedNameBenefitsHeadingElement) return;

    if (!rankedNameBenefitsHeadingElement.dataset.baseText) {
      rankedNameBenefitsHeadingElement.dataset.baseText = rankedNameBenefitsHeadingElement.textContent.trim();
    }

    const primaryRows = Array.from(container.querySelectorAll('[data-ranked-primary-row]'));
    const selectedPrimaryRow = primaryRows.find((row) => row.classList.contains('is-selected')) || primaryRows[0];
    if (!selectedPrimaryRow) return;

    const headingText = (selectedPrimaryRow.dataset.headingText || '').trim();
    const baseText = rankedNameBenefitsHeadingElement.dataset.baseText || '';
    rankedNameBenefitsHeadingElement.textContent = headingText || baseText;
  };

  function initRankedLinkMapping(scope = document) {
        const rankedContainers = scope.querySelectorAll('.four-for-xxx-comparison-container--ranked');

        rankedContainers.forEach((rankedContainer) => {
            if (rankedContainer.dataset.rankedLinkMapInit === 'true') return;

            const primaryRows = Array.from(rankedContainer.querySelectorAll('[data-ranked-primary-row]'));
            const secondaryRows = Array.from(rankedContainer.querySelectorAll('[data-ranked-secondary-row]'));
            if (!primaryRows.length || !secondaryRows.length) return;

            const secondaryKeyCounts = new Map();
            secondaryRows.forEach((row) => {
                const rowKey = normalizeKey(row.dataset.rowKey);
                if (!rowKey) return;

                const count = secondaryKeyCounts.get(rowKey) || 0;
                secondaryKeyCounts.set(rowKey, count + 1);
            });

            const duplicateSecondaryKeys = Array.from(secondaryKeyCounts.entries())
                .filter(([, count]) => count > 1)
                .map(([key]) => key);

            if (duplicateSecondaryKeys.length) {
                console.warn(
                    '[four-for-xxx] Duplicate secondary row keys found. Ranked mappings require unique secondary keys.',
                    duplicateSecondaryKeys
                );
            }

            secondaryRows.forEach((row) => {
                const rowKey = normalizeKey(row.dataset.rowKey);
                const isDuplicate = rowKey && duplicateSecondaryKeys.includes(rowKey);

                row.classList.toggle('has-key-conflict', Boolean(isDuplicate));
            });

            const secondaryKeySet = new Set(
                secondaryRows
                    .map((row) => normalizeKey(row.dataset.rowKey))
                    .filter(Boolean)
            );

            primaryRows.forEach((row) => {
                const mappedKeys = parseKeys(row.dataset.secondaryTrueKeys);
                const unknownMappedKeys = mappedKeys.filter((key) => !secondaryKeySet.has(key));

                if (unknownMappedKeys.length) {
                    console.warn(
                        '[four-for-xxx] Primary row contains mapped secondary keys that do not match any secondary row key.',
                        {
                            rankScore: row.dataset.rankScore,
                            mappedKeys: unknownMappedKeys
                        }
                    );
                }

                row.classList.toggle('has-mapping-conflict', unknownMappedKeys.length > 0);
            });

            const setSelectedState = (selectedRow) => {
                const mappedKeys = parseKeys(selectedRow.dataset.secondaryTrueKeys);
                const rankScore = Number.parseInt(selectedRow.dataset.rankScore || '0', 10);
                const mappedKeySet = new Set(mappedKeys);

                primaryRows.forEach((row) => {
                    const isSelected = row === selectedRow;
                    row.classList.toggle('is-selected', isSelected);

                    const link = row.querySelector('.four-for-xxx-comparison-container__ranked-link');
                    if (link) link.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
                });

                secondaryRows.forEach((row, index) => {
                    const rowKey = normalizeKey(row.dataset.rowKey);
                    let isTrue = false;

                    if (mappedKeySet.size > 0) {
                        isTrue = mappedKeySet.has(rowKey);
                    } else if (rankScore > 0) {
                        // fallback if no explicit key mapping is provided.
                        isTrue = index < rankScore;
                    }

                    row.classList.toggle('is-true', isTrue);
                    row.classList.toggle('is-false', !isTrue);
                });

                updateIncludedBenefitsCountForContainer(rankedContainer);
                updateRankedNameBenefitsHeadingForContainer(rankedContainer);
            };

            primaryRows.forEach((row) => {
                const link = row.querySelector('.four-for-xxx-comparison-container__ranked-link');
                if (!link) return;

                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    setSelectedState(row);
                });
            });

            setSelectedState(primaryRows[0]);
            rankedContainer.dataset.rankedLinkMapInit = 'true';
        });
    }

  initRankedLinkMapping();
  updateIncludedBenefitsCount();

  document.addEventListener('shopify:section:load', (event) => {
    initRankedLinkMapping(event.target || document);
    updateIncludedBenefitsCount(event.target || document);
    updateRankedNameBenefitsHeadingForContainer(event.target || document);
  });
})();